window.hljs = require('highlight.js');
window.axios = require('axios');
window.Vue = require('vue');
window.whatInput = require('what-input');
window.env = require('./support/Env').default;

window.axios.defaults.headers.common['X-CSRF-TOKEN'] = document.getElementById('csrf-token').content;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

if(process.env.NODE_ENV === 'production'){
    var bugsnag = require('@bugsnag/js');
    var bugsnagVue = require('@bugsnag/plugin-vue');

    var bugsnagClient = bugsnag('47e19a0f4379b022fe12c8e11f2b22f3');
    bugsnagClient.use(bugsnagVue, window.Vue);
}

require('./support/L10n.js');
require('./support/what-input.js');

window.isViewport = (res, height) => {
    var w = window,
        d = document,
        e = d.documentElement,
        g = d.getElementsByTagName('body')[0],
        x = w.innerWidth || e.clientWidth || g.clientWidth,
        y = w.innerHeight || e.clientHeight || g.clientHeight;

    return res <= (typeof height !== "undefined" && height ? y : x);
}

import EvilCorp from './support/EvilCorp';

let EventBus = new Vue();

Object.defineProperties(Vue.prototype, {
    $bus: {
        get: function() {
            return EventBus;
        }
    },
    $evilCorp: {
        get: function() {
            return $evilCorp;
        }
    },
});

// $evilCorp must be defined after Vue.$bus
const $evilCorp = new Vue(EvilCorp);

Element.prototype.appendBefore = function (target) {
    var t = typeof target === 'string'
        ? document.querySelector(target)
        : target;

    if (this.nextSibling === t) return;

    t.parentNode.insertBefore(this, t);
}

Element.prototype.appendAfter = function (target) {
    var t = typeof target === 'string'
        ? document.querySelector(target)
        : target;

    if (this.previousSibling === t) return;

    if (typeof t.nextSibling === "undefined") {
        t.parentNode.append(this);
    } else {
        t.parentNode.insertBefore(this, t.nextSibling);
    }
}

Element.prototype.getInnerHeight = function () {
    var computedStyle = getComputedStyle(this);
    return this.offsetHeight ? this.offsetHeight - parseFloat(computedStyle.paddingTop) - parseFloat(computedStyle.paddingBottom) : 0;
}

if (!Element.prototype.matches) {
    Element.prototype.matches =
        Element.prototype.matchesSelector ||
        Element.prototype.mozMatchesSelector ||
        Element.prototype.msMatchesSelector ||
        Element.prototype.oMatchesSelector ||
        Element.prototype.webkitMatchesSelector ||
        function(s) {
            var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                i = matches.length;
            while (--i >= 0 && matches.item(i) !== this) {}
            return i > -1;
        };
}
